/**
 * Custom hook for handling modal Esc key closure
 * Provides consistent Esc key functionality across all modals
 */

import { useEffect } from 'react';

export const useEscKeyHandler = (isOpen, onClose) => {
  useEffect(() => {
    const handleEscKey = (event) => {
      if (event.key === 'Escape' && isOpen) {
        onClose();
      }
    };

    // Add event listener when modal is open
    if (isOpen) {
      document.addEventListener('keydown', handleEscKey);
    }

    // Cleanup event listener
    return () => {
      document.removeEventListener('keydown', handleEscKey);
    };
  }, [isOpen, onClose]);
};

export default useEscKeyHandler;